import { RedirectRequest } from '@azure/msal-browser';
import { scopes } from './config';

export const silentRequest: RedirectRequest = {
	scopes: scopes,
	state: `${window.location.pathname}${window.location.search}`
};

export const loginRequest: RedirectRequest = {
	...silentRequest,
	prompt: 'select_account'
};
